<template>
  <div class="wrapper">

    <div class="page-header page-header-large">
      <parallax
          class="page-header-image"
          style="background-image: url('img/presentation/home_main.jpg')"
        ></parallax>

      <div class="container" style="padding-top: 250px;">
        <div class="row">
          <div class="col-lg-5 col-md-7 ml-auto mr-auto">
            <h2 class="title">{{ $t('PresentationParallaxDescription') }}</h2>

            <!-- <h6 class="category">Technology to combat pollution</h6> -->
          
            <!-- 
            <h5 class="description" style="color: #ffffff;">
              AiCAR can fully incorporate brand design guidelines and strategy into the platform.
              All functions and features are fully customisable: our ecosystem of services can also be integrated into existing applications on a selective basis – allowing you to create the best solution.
              Our Air.Car and Pay.Car platforms can also be integrated with your current systems, allowing you to create the best connected car experience possible.
            </h5>
             -->
             
          </div>

          <!-- <div class="col-md-5"> -->
          <div class="col-lg-6 col-md-12">
            <div class="image-container">
              <!-- class="img img-raised rounded img-comments rellax" -->
              <img
                class="img"
                data-rellax-speed="1"
                src="img/presentation/phonewithdevice-410x600.png"
                alt=""
              />
            </div>
          </div>
        </div>


      </div>
    </div>



    <!-- <div class="section section-basic-components"> -->
      <div class="about-office" style="padding-bottom: 10px;">
      <div class="container">
        <div class="row">
          <div class="col-lg-5 col-md-7 ml-auto mr-auto">
            <h2 class="title">{{ $t('PresentationSection2Title') }}</h2>
            <h6 class="category">{{ $t('PresentationSection2Description') }}</h6>
            <h5 class="description">{{ $t('PresentationSection2ContentText') }}</h5>
          </div>

          <!-- <div class="col-md-5"> -->
          <div class="col-lg-6 col-md-12">
            <div class="image-container">
              <!-- class="img img-raised rounded img-comments rellax" -->
              <img
                class="img"
                data-rellax-speed="1"
                src="img/presentation/open-platform.jpg"
                alt="content 1"
              />
            </div>
          </div>

          <!-- 
          <div class="col-lg-6 col-md-12">
            <div class="image-container">
              <img class="components-macbook" src="img/ipad.png" alt="ipad_img" />
              <img class="table-img" src="img/presentation-page/table.jpg" alt="table" />
              <img
                class="share-btn-img"
                src="img/presentation-page/share-btn.jpg"
                alt="share button"
              />
              <img
                class="coloured-card-btn-img"
                src="img/presentation-page/coloured-card-with-btn.jpg"
                alt="coloured card with button"
              />
              <img
                class="coloured-card-img"
                src="img/presentation-page/coloured-card.jpg"
                alt="coloured card"
              />
              <img class="social-img" src="img/presentation-page/social-row.jpg" alt="social row" />
              <img
                class="linkedin-btn-img"
                src="img/presentation-page/linkedin-btn.jpg"
                alt="linked in button"
              />
            </div>
          </div>
          -->
        </div>
      </div>
    </div>

    <div class="section section-basic-components">
      <div class="container">
        <div class="row">
          <!-- <div class="col-md-5"> -->
          <div class="col-lg-6 col-md-12">
            <div class="image-container">
              <!-- class="img img-raised rounded img-comments rellax" -->
              <img
                class="img"
                data-rellax-speed="1"
                src="img/presentation/ecosystem-services-connected-car-600x452.png"
                alt="content 1"
              />
            </div>
          </div>

          <div class="col-lg-5 col-md-7 ml-auto mr-auto">
            <h2 class="title">{{ $t('PresentationSection3Title') }}</h2>
            <h6 class="category">{{ $t('PresentationSection3Description') }}</h6>
            <h5 class="description">{{ $t('PresentationSection3ContentText') }}</h5>
          </div>
        </div>
      </div>
    </div>

    <div class="section section-basic-components">
      <div class="container">
        <div class="row">
          <div class="col-lg-5 col-md-7 ml-auto mr-auto">
            <h2 class="title">{{ $t('PresentationSection4Title') }}</h2>
            <h6 class="category">{{ $t('PresentationSection4Description') }}</h6>
            <h5 class="description">{{ $t('PresentationSection4ContentText') }}</h5>
          </div>

          <!-- <div class="col-md-5"> -->
          <div class="col-lg-6 col-md-12">
            <div class="image-container">
              <!-- class="img img-raised rounded img-comments rellax" -->
              <img
                class="img"
                data-rellax-speed="1"
                src="img/presentation/environmental-connected-car-600x502.png"
                alt="content 1"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="section section-cards" data-background-color="black">
      <div class="container">
        <div class="row">
          <div class="col-md-8 text-center ml-auto mr-auto">
            <div class="section-description">
              <h2 class="title">{{ $t('PresentationSection5Title') }}</h2>
              <h6 class="category">Awarded for our Commitment to Innovation</h6> 
                <h5 class="description">
                Awarded for our Commitment to Innovation
              </h5>
            </div>
          </div>
        </div> -->
<!-- 
        <div class="our-clients">
          <div class="container">
            <div class="row">
              <div class="col-md-3 ml-auto">
                <img v-lazy="'img/presentation/techtrak2015.png'" alt />
              </div>
              <div class="col-md-3">
                <img v-lazy="'img/presentation/techtrack2016.png'" alt />
              </div>
              <div class="col-md-3">
                <img v-lazy="'img/presentation/gp-bullhound.png'" alt />
              </div>
              <div class="col-md-3 mr-auto">
                <img v-lazy="'img/presentation/techxlr8.png'" alt />
              </div>
            </div>
          </div>
        </div> -->

        <!-- 
        <div class="row">
          <div class="col-md-12">
            <div class="images-container">
              <div class="image-container1">
                <img v-lazy="'img/presentation/techtrak2015.png'" alt="card 3" />
              </div>
              <div class="image-container2">
                <img v-lazy="'img/presentation/techtrack2016.png'" alt="card 6" />
              </div>
              <div class="image-container3">
                <img v-lazy="'img/presentation/gp-bullhound.png'" alt="card 7" />
              </div>
              <div class="image-container4">
                <img v-lazy="'img/presentation/techxlr8.png'" alt="card 5" />
              </div>
            </div>
          </div>
        </div>
        -->
      <!-- </div>
    </div> -->

    <div class="section section-pricing" id="sectionBuy">
      <div class="container">
        <!-- 
        <div class="our-clients">
          <div class="container">
            <div class="row">
              <div class="col-md-2 ml-auto">
                <img v-lazy="'img/presentation-page/vodafone.jpg'" alt />
              </div>
              <div class="col-md-2">
                <img v-lazy="'img/presentation-page/microsoft.jpg'" alt />
              </div>
              <div class="col-md-2">
                <img v-lazy="'img/presentation-page/harvard.jpg'" alt />
              </div>
              <div class="col-md-2 mr-auto">
                <img v-lazy="'img/presentation-page/stanford.jpg'" alt />
              </div>
            </div>
          </div>
        </div>
        -->

        <div class="row">
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h2 class="title">{{ $t('PresentationSection6Title') }}</h2>
          </div>
          <div class="col-md-8 ml-auto mr-auto">
            <p class="description mb-5 text-center">
              {{ $t('PresentationSection6ContentText1') }}
              <br />

              {{ $t('PresentationSection6ContentText2') }}
              <!-- 
              <br />Read more about
              <b>
                <a href="https://www.creative-tim.com/license" target="_blank">licenses here</a>
              </b>.
              -->
            </p>
          </div>

          <!-- 
          <div class="text-center col-md-8 ml-auto mr-auto">
            <h3>Thank you for supporting us!</h3>
          </div>
          -->

          <!-- 
          <div class="text-center col-md-8 ml-auto mr-auto">
            <a
              href="#pablo"
              class="btn btn-icon btn-lg btn-round btn-twitter twitter-sharrre sharrre"
              rel="tooltip"
              title
              data-original-title="Tweet!"
            >
              <i class="fab fa-twitter"></i>
            </a>
            <a
              href="#pablo"
              class="btn btn-lg btn-round btn-icon btn-facebook facebook-sharrre sharrre"
              rel="tooltip"
              title
              data-original-title="Share!"
            >
              <i class="fab fa-facebook-square"></i>
            </a>
            <a
              href="#pablo"
              class="btn btn-lg btn-round btn-icon btn-linkedin linkedin-sharrre sharrre"
              rel="tooltip"
              title
              data-original-title="Share!"
            >
              <i class="fab fa-linkedin"></i>
            </a>
            <a
              href="https://github.com/creativetimofficial/vue-now-ui-kit"
              class="btn btn-lg btn-round btn-icon btn-github"
              rel="tooltip"
              title
              data-original-title="Star on Github"
            >
              <i class="fab fa-github"></i>
            </a>
          </div>
          -->
        </div>
      </div>
    </div>

    <!-- 
    <div class="section section-pricing" id="sectionBuy">
      <div class="container">
        <div class="our-clients">
          <div class="container">
            <div class="row">
              <div class="col-md-2 ml-auto">
                <img v-lazy="'img/presentation-page/vodafone.jpg'" alt />
              </div>
              <div class="col-md-2">
                <img v-lazy="'img/presentation-page/microsoft.jpg'" alt />
              </div>
              <div class="col-md-2">
                <img v-lazy="'img/presentation-page/harvard.jpg'" alt />
              </div>
              <div class="col-md-2 mr-auto">
                <img v-lazy="'img/presentation-page/stanford.jpg'" alt />
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h2 class="title">Ready to grab Now UI Kit PRO?</h2>
          </div>
          <div class="col-md-8 ml-auto mr-auto">
            <p class="description mb-5 text-center">
              You have
              <b>Free Unlimited Updates</b> and
              <b>Premium Support</b> on each package. You also have
              <b>30 days</b> to request a refund if you're not happy with your purchase.
              <br />Read more about
              <b>
                <a href="https://www.creative-tim.com/license" target="_blank">licenses here</a>
              </b>.
            </p>
            <div class="row">
              <div class="col-md-6">
                <card
                  type="background"
                  raised
                  class="card-pricing card-margin"
                  style="background-image: url('img/bg27.jpg')"
                >
                  <h6 class="category">Personal License</h6>
                  <h1 class="card-title">
                    <small>$</small>
                    69
                  </h1>
                  <ul>
                    <li>
                      <b>HTML/CSS/JS/SASS</b> Files
                    </li>
                    <li>
                      <b>Fully Coded</b> Components
                    </li>
                    <li>
                      <b>Responsive</b> Design
                    </li>
                    <li>
                      Product
                      <b>Documentation</b>
                    </li>
                  </ul>
                  <a
                    href="https://www.creative-tim.com/buy/vue-now-ui-kit-pro?license=1"
                    class="btn btn-primary btn-round"
                  >Buy Now!</a>
                </card>
              </div>
              <div class="col-md-6">
                <card
                  type="background"
                  raised
                  class="card-pricing"
                  style="background-image: url('img/bg37.jpg')"
                >
                  <h6 class="category">Developer License</h6>
                  <h1 class="card-title">
                    <small>$</small>
                    279
                  </h1>
                  <ul>
                    <li>Everything in Personal</li>
                    <li>
                      <b>+</b> Create
                      <b>Multiple Websites</b>
                    </li>
                    <li>
                      <b>+</b> Sell to
                      <b>Multiple Clients</b>
                    </li>
                    <li>
                      <b>+</b> Can
                      <b>Charge Customers</b>
                    </li>
                    <li>
                      <b>+</b> Use in
                      <b>Commercial Projects</b>
                    </li>
                    <li>
                      <b>+</b> Use in
                      <b>SaaS Projects</b>
                    </li>
                  </ul>
                  <a
                    href="https://www.creative-tim.com/buy/vue-now-ui-kit-pro?license=2"
                    class="btn btn-primary btn-round"
                  >Buy Now!</a>
                </card>
              </div>
            </div>
          </div>
          <div class="text-center col-md-8 ml-auto mr-auto">
            <h3>Thank you for supporting us!</h3>
          </div>
          <div class="text-center col-md-8 ml-auto mr-auto">
            <a
              href="#pablo"
              class="btn btn-icon btn-lg btn-round btn-twitter twitter-sharrre sharrre"
              rel="tooltip"
              title
              data-original-title="Tweet!"
            >
              <i class="fab fa-twitter"></i>
            </a>
            <a
              href="#pablo"
              class="btn btn-lg btn-round btn-icon btn-facebook facebook-sharrre sharrre"
              rel="tooltip"
              title
              data-original-title="Share!"
            >
              <i class="fab fa-facebook-square"></i>
            </a>
            <a
              href="#pablo"
              class="btn btn-lg btn-round btn-icon btn-linkedin linkedin-sharrre sharrre"
              rel="tooltip"
              title
              data-original-title="Share!"
            >
              <i class="fab fa-linkedin"></i>
            </a>
            <a
              href="https://github.com/creativetimofficial/vue-now-ui-kit"
              class="btn btn-lg btn-round btn-icon btn-github"
              rel="tooltip"
              title
              data-original-title="Star on Github"
            >
              <i class="fab fa-github"></i>
            </a>
          </div>
        </div>
      </div>
    </div>

    -->
  </div>
</template>

<script>
import { Card, InfoSection } from "@/components";
import { Carousel, CarouselItem, Tooltip } from "element-ui";

export default {
  name: "about-us",
  bodyClass: "about-us",

  /*   
  name: "presentation",
  bodyClass: "presentation-page",
   */

  components: {
    Card,
    InfoSection,
    [Carousel.name]: Carousel,
    [CarouselItem.name]: CarouselItem,
    [Tooltip.name]: Tooltip
  }
};
</script>

<style scoped lang="scss">
.github-buttons {
  display: flex;
  align-content: center;
}
</style>
